import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_GET_USER_DETAILS, FAB_SURGE_GET_USER_DETAILS_ERROR, FAB_SURGE_GET_USER_DETAILS_SUCCESS } from '../../../actions.js';

function* getFabUserDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/card-data-detailed-view`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: FAB_SURGE_GET_USER_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_GET_USER_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_GET_USER_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetFabUserDetails() {
  yield takeEvery(FAB_SURGE_GET_USER_DETAILS, getFabUserDetails);
}

function* getFabUserDetailsSaga() {
  yield all([fork(watchGetFabUserDetails)]);
}

export default getFabUserDetailsSaga;
